export const CASE_CATEGORIES = [
  { label: 'Оила ҳуқуқи', subs: [
    'Никоҳни бекор қилиш (Ажрашиш)',
    'Алимент ундириш',
    'Мерос масаласи',
    'Мол-мулкни бўлиш ёки олиб бериш',
    'Бола билан учраштириш',
    'Болани олиб бериш',
    'Уйга киритиш',
    'Уйдан чиқариш',
    'Оила ҳуқуқи (бошқа)',
  ]},
  { label: 'Фуқаролик ҳуқуқи', subs: [
    'Қарз (пул) ундириш',
    'Субсидия',
    'Кредит олиш',
    'Чегарага тақиқ қўйиш ёки тақиқни ечиш',
    'Олди-сотди муносабатлари',
    'Солиқ низолари',
    'Ер низолари',
    'Кўчмас мулк низолари',
    'Бино (уй, квартира) кадастр қилиш',
    'Истеъмолчи ҳуқуқини бузиш',
    'Фуқаролик ҳуқуқи (бошқа)',
  ]},
  { label: 'Меҳнат ҳуқуқи', subs: [
    'Ишга кириш',
    'Ишга тиклаш',
    'Иш ҳақи ундириш',
    'Компенсация ундириш',
    'Интизомий жазони бекор қилиш',
    'Меҳнат ҳуқуқи (бошқа)',
  ]},
  { label: 'Жиноят ҳуқуқи', subs: [
    'Фирибгарлик',
    'Ўғрилик',
    'Баданга шикаст етказиш',
    'Безорилик',
    'Гиёҳвандлик',
    'Ўзлаштириш ва растрата йўли билан талон-тарож қилиш',
    'Жиноят ҳуқуқи (бошқа)',
  ]},
  { label: 'Тадбиркорлик ҳуқуқи', subs: [
    'Тадбиркорлик очиш (рўйхатдан ўтказиш)',
    'Солиқ низолари (текширув)',
    'Ортиқча солиқни қайтариш',
    'Шартнома тайёрлаш',
    'Имтиёзни қўллаш ва олиш',
    'Божхона низолари',
    'Таъсис ҳужжатлари тайёрлаш (ўзгартириш, қўшиш)',
    'Тадбиркорликни ёпиш (реестрдан чиқариш)',
    'Патентлаш (интеллектуал мулк ҳуқуқи)',
    'Тадбиркорлик ҳуқуқи (бошқа)',
  ]},
  { label: 'Қурилиш ҳуқуқи', subs: [
    'Қурилишга рухсат олиш',
    'Қурилиш жараёни ҳужжатларини тайёрлаш',
    'Кадастр ҳужжатларини тайёрлаш',
    'Қурилишни якунлаш ва объектни фойдаланишга қабул қилиш',
    'Кўчирма (давлат рўйхатидан ўтказиш) олиш',
    'Қурилиш ҳуқуқи (бошқа)',
  ]},
  { label: 'Маъмурий ҳуқуқбузарлик', subs: [
    'ГАИ жаримаси',
    'Майда безорилик',
    'Милиция жарималар',
    'Милиция олиб кетди',
    'Суд жаримаси',
    'Маъмурий ҳуқуқбузарлик (бошқа)',
  ]},
  { label: 'Бошқа турдаги ишлар', subs: [] },
];

export const ALL_CATEGORY_VALUES = CASE_CATEGORIES.flatMap(cat =>
  cat.subs.length > 0 ? cat.subs : [cat.label]
);
